<section id="how-it-works">
  @defer(on viewport) {
  <header class="text-center">
    <h2 class="h3-responsive font-bold mb-20">HOW IT WORKS</h2>
  </header>
  <section class="flex flex-col items-center gap-8">
    @for (howWork of howWorks;let step = $index; track $index) {
    <article class="how-work mon-card">
      <div class="step">{{ step + 1 }}</div>
      <div class="card-body">
        <p class="h3-responsive font-bold my-4">
          {{ howWork.title }}
        </p>
        <p class="text-gray-500 h5-responsive" [innerHTML]="howWork.description"></p>
      </div>
    </article>
    }
  </section>
  }@placeholder {
  <div class="spinner-center">
    <mat-spinner></mat-spinner>
  </div>
  }
</section>
